import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { CreateMyPasswordContent } from '../model/create-my-password';

export const CreateMyPasswordMock: CreateMyPasswordContent = {
  formGroup: new UntypedFormGroup({
    newPassword: new UntypedFormControl(null, [Validators.required]),
    confirmPassword: new UntypedFormControl(null, [Validators.required])
  }),
  pageContent: {
    pageHeader: {
      logoUrl: '',
      altText: '',
      headerSubTitle: 'All fields are required',
      headerTitle: 'Reset My Password'
    },
    canNotContainLabel: 'CANNOT CONTAIN',
    cannotContainList: [
      'More than 3 special characters',
      'The @ and < symbols',
      'Your SkyMiles number, Email or Username'
    ],
    confirmPasswordLabel: 'Re-Enter New Password',
    confirmPasswordText: 'Re-Enter New Password',
    mustContainLabel: 'MUST CONTAIN',
    mustContainList: [
      'At least 8 and at most 20 characters',
      '1 number and 1 letter',
      '1 uppercase and 1 lowercase letter'
    ],
    newPasswordLabel: 'New Password',
    newPasswordText: 'New Password',
    nextDisplayView: {
      button_continue: '',
      button_createPassword: '',
      button_forgotPassword: '',
      button_loginHelp: '',
      button_modal: 'Continue',
      button_resetPassword: '',
      button_sendLogin: '',
      button_wfp: '',
      nextViewName: 'loginCredentials',
      nextViewName_createPassword: '',
      nextViewName_email: '',
      nextViewName_forgotPassword: '',
      nextViewName_loginHelp: '',
      nextViewName_resetPassword: '',
      nextViewName_sendLogin: '',
      nextViewName_sqa: '',
      overlayMessage:
        'Your password has been reset successfully. We have sent a confirmation email to your primary email address in your Delta account.',
      refreshUrl: ''
    },
    viewName: 'setPassword',
    messages: {
      newPasswordErrorMessage: '',
      confirmPasswordErrorMessage: '',
      alertWarning: '',
      cannotContainValidationList: [],
      mustContainValidationList: []
    },
    showPassword: false
  },
  formAttributes: {
    errorCount: 0,
    submitAttempt: false,
    errorAlertBanner: false,
    newPasswordControlTouched: false,
    confirmPasswordControlTouched: false,
    disableActionButton: false
  },
  showOverlayMessage: false,
  overlayMessage:
    'Your password has been reset successfully. We have sent a confirmation email to your primary email address in your Delta account.'
};
